export default __webpack_public_path__ + "static/title-pack-fab4b3bd40e9f9bf9803aed49dd05234.png";